export default {"src":"/_next/static/media/Favicon w.2f2f3447.svg","height":311,"width":311,"blurWidth":0,"blurHeight":0};